import { computed, toValue } from "vue";
export const PA_NOT_SUBMITTING_NOTICE = "Lamar is not submitting this PA. Use tags to track your submission.";
/** The acting company hides Prior Auth: its module list leaves it out; no list keeps Prior Auth visible. */
export function companyHidesPriorAuth(modules) {
    return !!modules?.length && !modules.includes("prior_auth");
}
/** The order's owner hides Prior Auth, as the server decides it, so the client submits this PA itself. */
export function useOrderPriorAuthHidden(order) {
    return computed(() => Boolean(toValue(order)?.priorAuthHidden));
}
